/* GYNGRAF Premium — scripts propios */
(function () {
  if (window.__gpCargado) return;
  window.__gpCargado = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gp-rv:not(.gp-on)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('gp-on'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('gp-on'); io.unobserve(e.target); } });
    }, { threshold: .1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initContadores(root) {
    var nums = (root || document).querySelectorAll('[data-gp-count]:not([data-gp-ok])');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, fin = parseInt(el.getAttribute('data-gp-count'), 10), suf = el.getAttribute('data-suf') || '';
        el.setAttribute('data-gp-ok', '1');
        if (reduce) { el.textContent = fin + suf; return; }
        var t0 = null;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / 1500, 1), k = 1 - Math.pow(1 - p, 3);
          if (p > 0) el.textContent = Math.round(fin * k) + suf; // el primer cuadro no muestra 0 (Google lo capturaba como "0+")
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: .4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-gp-tabs]:not([data-gp-ok])').forEach(function (box) {
      box.setAttribute('data-gp-ok', '1');
      var tabs = box.querySelectorAll('.gp-tab'), panels = box.querySelectorAll('.gp-panel');
      var mas = box.querySelector('[data-gp-mas]');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.setAttribute('aria-selected', i === j); });
          panels.forEach(function (p, j) { p.hidden = i !== j; });
          if (mas) { mas.href = t.getAttribute('data-url'); mas.querySelector('span').textContent = t.getAttribute('data-txt'); }
        });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('.gp-sticky');
    if (!bar) return;
    // Primero el botón principal de WhatsApp; si no existe, el formulario del producto
    var ancla = document.querySelector('[data-gp-wa]') || document.querySelector('product-form, .product-form, form[action*="/cart/add"], .product-details');
    if (!ancla || !('IntersectionObserver' in window)) return;
    bar.style.transform = 'translateY(110%)';
    bar.style.transition = 'transform .45s cubic-bezier(.22,1,.36,1)';
    // El botón de la barra usa el mismo mensaje del botón principal (empresa/evento, cantidad y fecha)
    var principal = document.querySelector('[data-gp-wa]'), link = bar.querySelector('a');
    if (principal && link) link.addEventListener('click', function () { link.href = principal.href; });
    new IntersectionObserver(function (en) {
      var e = en[0], on = principal ? !e.isIntersecting : (!e.isIntersecting && e.boundingClientRect.top < 0);
      bar.style.transform = on ? 'none' : 'translateY(110%)';
      // Solo se ocultan la burbuja y "Mi cotización" cuando la barra se ve (en escritorio no existe)
      document.documentElement.classList.toggle('gp-sticky-on', on && getComputedStyle(bar).display !== 'none');
    }).observe(ancla);
  }

  function init(root) { initReveal(root); initContadores(root); initTabs(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initSticky(); });
  else { init(); initSticky(); }

  /* Respaldo por posición (navegadores que no avisan al bajar) */
  (function () {
    var pend = false;
    function revisar() {
      pend = false; var lim = innerHeight * 0.92;
      document.querySelectorAll('.gp-rv:not(.gp-on)').forEach(function (e) { if (e.getBoundingClientRect().top < lim) e.classList.add('gp-on'); });
      var bar = document.querySelector('.gp-sticky');
      var ancla = bar && (document.querySelector('[data-gp-wa]') || document.querySelector('product-form, .product-form, form[action*="/cart/add"], .product-details'));
      if (bar && ancla) { var r = ancla.getBoundingClientRect(), on = ancla.hasAttribute('data-gp-wa') ? (r.bottom < 0 || r.top > innerHeight) : r.bottom < 0; bar.style.transform = on ? 'none' : 'translateY(110%)'; document.documentElement.classList.toggle('gp-sticky-on', on && getComputedStyle(bar).display !== 'none'); }
    }
    addEventListener('scroll', function () { if (!pend) { pend = true; setTimeout(revisar, 120); } }, { passive: true });
    setTimeout(revisar, 1500);
  })();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
